"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monitorFrequency = void 0;
exports.monitorFrequency = 2000;
//# sourceMappingURL=stats.js.map